import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import IMenu from '@/js/components/molecules/IMenu.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'sort',
  props: {
    sort: { default: 'update' }
  },
  setup(__props: any) {

const props = __props as { sort: string };


const list = [
  {
    sort: 'update',
    text: '更新順',
  },
  {
    sort: 'area',
    text: 'エリア順',
  },
];
const label = computed(() => list.find((item) => item.sort === props.sort)?.text || '');

return { __sfc: true,props, list, label, IMenu }
}

})